import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, MessageCircle } from 'lucide-react';

const quickLinks = [
  { label: '首页', href: '/' },
  { label: '资讯中心', href: '/articles' },
  { label: '在线商城', href: '/shop' },
  { label: '招商中心', href: '/investment' },
];

const serviceLinks = [
  { label: '精准营销', href: '/marketing' },
  { label: '数字资源', href: '/resources' },
  { label: '分销合作', href: '/distribution' },
  { label: '招商入驻', href: '/investment' },
  { label: '在线采购', href: '/shop' },
];

const socialLinks = [
  { label: '微信', icon: MessageCircle },
  { label: '微博', icon: MessageCircle },
  { label: 'LinkedIn', icon: MessageCircle },
];

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="section-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="text-xl font-bold">互联网生态平台</span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              成都孔明智算互联网科技有限公司致力于构建数字化生态平台，为企业提供全方位的数字化解决方案。
            </p>
            {/* <div className="flex gap-3">
              {socialLinks.map((social) => (
                <button
                  key={social.label}
                  className="w-10 h-10 rounded-lg bg-gray-800 flex items-center justify-center transition-all duration-300 hover:bg-[#1c5bff] hover:scale-110 group"
                  title={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </button>
              ))}
            </div> */}
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">快速链接</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-gray-400 text-sm transition-all duration-300 hover:text-white hover:translate-x-1 inline-block"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          {/* <div>
            <h4 className="text-lg font-semibold mb-4">服务项目</h4>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-gray-400 text-sm transition-all duration-300 hover:text-white hover:translate-x-1 inline-block"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">联系我们</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#1c5bff] flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">
                  四川省成都市武侯区九架车巷55号悦湖数园1栋
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#1c5bff] flex-shrink-0" />
                <span className="text-gray-400 text-sm">028-85002901</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#1c5bff] flex-shrink-0" />
                <span className="text-gray-400 text-sm">contact@kongming.com</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="section-container py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © 2026 成都孔明智算互联网科技有限公司. 保留所有权利.
            </p>
            <div className="flex items-center gap-6">
              <Link to="https://beian.miit.gov.cn/" className="text-gray-500 text-sm hover:text-white transition-colors">
              蜀ICP备2026021924号-1
              </Link>
              <Link to="https://beian.mps.gov.cn/#/query/webSearch?code=51010702044228" className="text-gray-500 text-sm hover:text-white transition-colors">
              川公网安备51010702044228号
              </Link>
              <Link to="/privacy-policy" className="text-gray-500 text-sm hover:text-white transition-colors">
                隐私政策
              </Link>
              <Link to="/service-agreement" className="text-gray-500 text-sm hover:text-white transition-colors">
                服务条款
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
